import React from "react";

const RadioButtonGroup = ({
  name,
  id = "",
  label,
  ariaLabel = "",
  selectedValue,
  errorMessage,
  handleChange,
  options,
  required = false,
  disabled = false,
  "aria-label": ariaLabelProp,
  "aria-required": ariaRequiredProp,
}) => {
  const isRequired = ariaRequiredProp !== undefined ? ariaRequiredProp : required;
  const groupLabel =
    ariaLabelProp ||
    ariaLabel ||
    (typeof label === "string" && label.trim() ? label.trim() : "") ||
    (typeof name === "string" && name.trim() ? name.trim() : "");

  return (
    <div>
      {label && (
        <label className="form-label col-form-label text-black  w-100 fs-5 form-label-custom-visible">
          {label} {isRequired && <span className="text-danger">*</span>}
        </label>
      )}
      <div className="d-flex flex-wrap gap-4 text-black">
        {options?.map((option, i) => (
          <div key={option.value} className="form-check text-black">
            <input
              type="radio"
              className="form-check-input text-black"
              name={name}
              id={id + i}
              value={option.value}
              checked={selectedValue === option.value}
              onChange={handleChange}
              required={isRequired}
              aria-label={
                option?.label
                  ? groupLabel
                    ? `${groupLabel} - ${option.label}`
                    : option.label
                  : groupLabel || "Option"
              }
              aria-required={isRequired}
              disabled={option?.disabled ? option?.disabled : disabled}
            />
            <label
              className={
                "fs-5 " +
                (option?.label === "Disapprove" || option?.label === "Reject"
                  ? "label-red fw-bold"
                  : option?.label === "Approve"
                  ? "label-green fw-bold"
                  : "form-check-label")
              }
              htmlFor={id + i}
            >
              {option.label}
            </label>
          </div>
        ))}
      </div>
      {errorMessage && errorMessage[name] && (
        <div className="w-100 text-start text-danger fw-700 fs-6 mt-1">
          {errorMessage[name]}
        </div>
      )}
    </div>
  );
};

export default RadioButtonGroup;
